import React from 'react';
import PropTypes from 'prop-types';
import Button from 'partial/components/Button';
// import FormSelect from 'partial/form/FormSelect';
import { useDebouceEffect } from 'partial/form/hooks';
import FormInlineInput from 'partial/form/FormInlineInput';
import { HiFilter, HiOutlineSearch } from 'react-icons/hi';
import DropdownPanel from 'partial/components/DropdownPanel';

// const APPROVAL_STATUS_OPTIONS = [
//   { label: 'Approved', value: 'APPROVED' },
//   { label: 'In Review', value: 'IN_REVIEW' },
//   { label: 'Rejected', value: 'REJECTED' },
//   { label: 'Pending', value: 'PENDING' },
// ];

const DISABLED = false;

function MerchantListFilter({ onSubmit, value }) {
  const [form, setForm] = React.useState(value);
  const [showFilter, setShowFilter] = React.useState(false);
  useDebouceEffect(form.keyword, (keyword) => {
    onSubmit((state) => ({
      ...state,
      keyword,
    }));
  });
  // const handleChangeStatus = (v) => {
  //   setForm(v);
  //   onSubmit(v);
  // };
  const handleSubmit = (e) => {
    e.preventDefault();
    setShowFilter(false);
    onSubmit((state) => ({
      ...state,
      ...form,
    }));
  };
  const handleClear = () => {
    setForm((state) => ({
      ...state,
      keyword: '',
    }));
    onSubmit((state) => ({
      ...state,
      keyword: '',
    }));
  };
  return (
    <div>
      <form className="space-y-2" onSubmit={handleSubmit}>
        {/* <div>
          <FormSelect
            name="approval_status"
            onChange={handleChangeStatus}
            value={form.approval_status}
            options={APPROVAL_STATUS_OPTIONS}
            placeholder="All Status"
          />
        </div> */}
        <div className="flex space-x-4">
          <div className="flex-1 min-w-0 relative">
            <label htmlFor="search" className="sr-only">
              Search
            </label>
            <FormInlineInput
              className="pr-14"
              name="keyword"
              onChange={setForm}
              value={form.keyword}
              icon={HiOutlineSearch}
              placeholder="Search..."
            />
            {form.keyword ? (
              <button
                className="absolute top-0 right-0 py-2 px-3 font-semibold text-primary-500 hover:underline"
                type="button"
                onClick={handleClear}
              >
                Clear
              </button>
            ) : null}
          </div>
          {DISABLED ? (
            <button
              type="button"
              className="inline-flex justify-center px-3.5 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              onClick={() => setShowFilter(!showFilter)}
            >
              <HiFilter className="h-5 w-5 text-gray-400" aria-hidden="true" />
              <span className="sr-only">Filter</span>
            </button>
          ) : null}
        </div>
      </form>
      <DropdownPanel show={showFilter}>
        <div className="space-y-2">
          <div className="text-center text-sm font-semibold text-gray-600">
            - Advance Filter -
          </div>
          <div>MORE FILTERS HERE</div>
          <div className="flex space-x-2 justify-center">
            <Button primary size="xs" onClick={handleSubmit}>
              Apply
            </Button>
            <Button size="xs" onClick={() => setShowFilter(!showFilter)}>
              Cancel
            </Button>
          </div>
        </div>
      </DropdownPanel>
    </div>
  );
}

MerchantListFilter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.instanceOf(Object).isRequired,
};

export default MerchantListFilter;
